import moment from 'moment';

export function isCardExpiring(card, upcoming) {
  if (card && upcoming) {
    const nextPayment = {
      month: parseInt(moment(upcoming.nextPaymentAttempt).format('MM')),
      year: parseInt(moment(upcoming.nextPaymentAttempt).format('YYYY')),
    };
    if (
      card.expYear < nextPayment.year ||
      (card.expYear === nextPayment.year && card.expMonth < nextPayment.month)
    ) {
      return true;
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/helpers/card.js